import React, { useState, useEffect } from 'react';
import '../AutoSlider.css'

const AutoSlider = ({ images, interval = 3000 }) => {
    const productImgUrl = process.env.REACT_APP_Product_Images_URL;
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const nextSlide = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentImageIndex(
            (prevIndex) => (prevIndex - 1 + images.length) % images.length
        );
    };

    useEffect(() => {
        const intervalId = setInterval(nextSlide, interval);

        return () => {
            // Clean up the interval when the component unmounts
            clearInterval(intervalId);
        };
    }, [interval]);

    const handleDotClick = (index) => {
        setCurrentImageIndex(index);
    };

    return (
        <div className="auto-slider">
            {/* <button onClick={prevSlide}>Previous</button> */}
            {/* {console.log("sdhsajdhajdkadadkaj", images)} */}
            {images[currentImageIndex].Image &&
                <img
                    src={productImgUrl + images[currentImageIndex].Image}
                    alt={`Slide ${currentImageIndex + 1}`}
                    className="sliderImage autoscss"
                />
            }
            {/* <button onClick={nextSlide}>Next</button> */}

            <div className="dots">
                {images.map((_, index) => (
                    <span
                        key={index}
                        className={index === currentImageIndex ? 'dot active' : 'dot'}
                        onClick={() => handleDotClick(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default AutoSlider;
